// hotfix to avoid using react-dom/server which can cause issues in Next
// later the source of flow-icons2 should be used instead
export const agGridIconsDefinition = {
  previous: {
    // ArrowLeftIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.86 18.24L11.58 19.52L4.02 11.96L11.58 4.4L12.86 5.68L7.56 10.92H19.58V13H7.56L12.86 18.24Z"></path></svg>',
  },
  next: {
    // ArrowRightIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M4.42 10.92H16.44L11.14 5.68L12.42 4.4L19.98 11.96L12.42 19.52L11.14 18.24L16.44 13H4.42V10.92Z"></path></svg>',
  },
  first: {
    // ChevronPreviousIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.3 11.96L17.36 5L18.64 6.44L12.1 11.96L18.64 17.48L17.36 18.92L9.3 11.96ZM6.3 5.32H8.26V18.6H6.3V5.32Z"></path></svg>',
  },
  last: {
    // ChevronNextIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.7 11.96L6.64 18.92L5.36 17.48L11.9 11.96L5.36 6.44L6.64 5L14.7 11.96ZM17.7 18.6H15.74V5.32H17.7V18.6Z"></path></svg>',
  },
  'small-down': {
    // ChevronDownIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12 16.42L4.64 9.06L6.12 7.58L12 13.46L17.88 7.58L19.36 9.06L12 16.42Z"></path></svg>',
  },
  asc: {
    // ArrowCircleUpFilledIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM11.22 15.92H12.78V10.4L15.34 13.04L16.3 12.1L11.96 7.76L7.7 12.1L8.66 13.04L11.22 10.34V15.92Z"></path></svg>',
  },
  ascHover: {
    // ArrowCircleUpIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM12 4.98C8.2 4.98 5.06 8.14 5.06 11.96C5.06 15.78 8.2 18.94 12 18.94C15.8 18.94 18.94 15.78 18.94 11.96C18.94 8.14 15.8 4.98 12 4.98ZM11.22 15.92V10.36L8.66 13.04L7.7 12.1L12 7.76L16.3 12.1L15.34 13.04L12.78 10.36V15.92H11.22Z"></path></svg>',
  },
  desc: {
    // ArrowCircleDownFilledIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18ZM12.78 8H11.22V13.52L8.66 10.88L7.7 11.82L12.04 16.16L16.3 11.82L15.34 10.88L12.78 13.58V8Z"></path></svg>',
  },
  descHover: {
    // ArrowCircleDownIcon
    svg: '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="2 2 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18ZM12 18.94C15.8 18.94 18.94 15.78 18.94 11.96C18.94 8.14 15.8 4.98 12 4.98C8.2 4.98 5.06 8.14 5.06 11.96C5.06 15.78 8.2 18.94 12 18.94ZM12.78 8V13.56L15.34 10.88L16.3 11.82L12 16.16L7.7 11.82L8.66 10.88L11.22 13.56V8H12.78Z"></path></svg>',
  },
};

/** Maps AG Grid icons to Skoda Flow library icons, overrides icons in AG Grid Theme */
export const skodaAgGridIconOverrides = (customIcons?: { name: string; svg: string }[]) => {
  return {
    type: 'image' as const,
    mask: true, // for icons to use AG Grid currentColor
    icons: {
      ...agGridIconsDefinition,
      ...Object.fromEntries((customIcons ?? []).map((icon) => [icon.name, { svg: icon.svg }])),
    },
  };
};

export const agGridCssIcons = {
  '.ag-icon-desc:hover::before': {
    maskImage: `url(data:image/svg+xml;utf8,${encodeURIComponent(agGridIconsDefinition.descHover.svg)})`,
  },
  '.ag-icon-asc:hover::before': {
    maskImage: `url(data:image/svg+xml;utf8,${encodeURIComponent(agGridIconsDefinition.ascHover.svg)})`,
  },
};
